import CommonState from './CommonState'
import { getStateByCode, getNameByCode } from './CommonState'

export class ManifestCfmState {
  static CFM_STATE_NORMAL = new CommonState(0, '未邀请录入', 'Uninvited entry')
  static CFM_STATE_INPUT = new CommonState(1, '已邀请录入', 'Invited entry')
  static CFM_STATE_SUBMIT = new CommonState(2, '已提交', 'Submitted')
  static CFM_STATE_MODIFY = new CommonState(3, '已邀请修改', 'Invited to modify')
  static CFM_STATE_DONE = new CommonState(4, '已确认', 'Confirmed')
  static CFM_STATE_UNLOCK = new CommonState(5, '临时解锁', 'Temporary unlocking')

  static MANIFEST_STATES = [this.CFM_STATE_NORMAL, this.CFM_STATE_INPUT, this.CFM_STATE_SUBMIT, this.CFM_STATE_MODIFY, this.CFM_STATE_DONE, this.CFM_STATE_UNLOCK]

  /**
   * 根据代码获取状态
   * @param {Number} code
   */
  static getStateByCode(code) {
    return getStateByCode(this.MANIFEST_STATES, code)
  }
  /**
   * 根据代码获取中文名称
   * @param {Number} code
   */
  static getChineseNameByCode(code) {
    return getNameByCode(this.MANIFEST_STATES, code, 'zh')
  }
}
